import { Usage } from '@botpress/client'
import { Progress } from '@bpinternal/ui-kit-next'
import { clamp } from 'lodash'
import { ReactNode } from 'react'
import { cn } from '~/utils'
import { QUOTA_TYPE_USER_FACING_PROPERTIES_MAP } from '../features/usage/constants'
import { formatValueWithUnit } from '../features/usage/helpers'

type Props = { description?: ReactNode; title?: ReactNode } & Pick<Usage, 'type' | 'value' | 'quota'>
export const UsageProgressBar = ({ quota, type, value, description, title }: Props) => {
  const usagePercentage = quota ? clamp((value / quota) * 100, 0, 100) : 0

  return (
    <div key={type} className="flex flex-col gap-1">
      {title ? title : <p className="text-sm">{QUOTA_TYPE_USER_FACING_PROPERTIES_MAP[type].name}</p>}
      {description}
      <Progress
        value={usagePercentage}
        className={cn(
          usagePercentage >= 90
            ? 'bg-red-500/20 [&>div]:bg-red-500'
            : usagePercentage >= 70
              ? 'bg-yellow-500/20 [&>div]:bg-yellow-500'
              : 'bg-blue-500/20 [&>div]:bg-blue-500'
        )}
      />
      <p className="text-nowrap text-end text-xs text-muted-foreground">
        <span className="font-medium">{formatValueWithUnit(value, type)}</span> of {formatValueWithUnit(quota, type)}
      </p>
    </div>
  )
}
